import { InjectionToken } from '@angular/core';
import { RouterState } from '../entities';

/**
 * A token used to provide route change handler to the `{@link RouterEventsFacade}` using this as route change inteceptors.
 *
 * Prefer using {@link provideRouteChangeHandler} to provide route change handler instead of specifying this token directly.
 */
export const ROUTE_CHANGE_HANDLER = new InjectionToken('__ROUTE_CHANGE_HANDLER__');

export interface RouteChangeHandler {
    handleRouteChange(route: RouterState): void;
}
